import { useEffect, useRef } from "react";
import Image from "@/shared/components/Image/new";
import { loader } from "@/shared/functions/getImagesFunctions";
import styles from "./styles.module.css";
import { formatAuthorNames } from '@/shared/functions/formatAthorNames';
import { EnVivo } from "@/shared/components/enVivo";

const Destacada = (props) => {
  const { title, author, summary, url, image, hasBackground, metadata } = props;

  const rootRef = useRef(null);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;

    // 👉 ahora miramos al PARENT DEL PARENT
    const parent = el.parentElement;
    const grandParent = parent?.parentElement;
    if (!grandParent) return;

    const force33 = (node) => {
      // normalizamos espacios para comparar
      const w = (node.style?.width || "").replace(/\s+/g, "");
      if (w === "calc(34%)" || w === "34%") {
        node.style.width = "calc(33%)";
      }
    };

    // primera pasada
    force33(grandParent);

    // (opcional) si el width cambia dinámicamente, lo corregimos
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === "attributes" && m.attributeName === "style") {
          force33(grandParent);
        }
      }
    });
    try {
      mo.observe(grandParent, { attributes: true, attributeFilter: ["style"] });
    } catch {}

    return () => {
      try { mo.disconnect(); } catch {}
    };
  }, []);

  let authorsList = [];
  if (author != undefined && author?.length) {
    const authorName = formatAuthorNames(author[0].name);
    author.length > 1
      ? author.slice(0, 2).map(el => {
          const elementName = formatAuthorNames(el.name);
          return authorsList.push(el.slug ? `<a href=/autor/${el.slug}>${elementName}</a>` : elementName);
        })
      : authorsList.push(author[0].slug ? `<a href=/autor/${author[0].slug}>${authorName}</a>` : authorName);
  }
  const parsedAuthors = authorsList.join(' y ');
  const noTagsHtml = summary && summary.length && summary.replace(/<[^>]+>/g, '').replace(/&nbsp[;]?/ig, ' ');

  return (
    <>
      <a ref={rootRef} href={url} className={styles["destacada-container"]}>
        <div className={styles["img-container"]}>
          <Image
            src={image}
            alt={title}
            width={630}
            height={420}
            loader={loader}
            className={styles['img']}
            priority
          />
          {metadata && metadata.typeWeb === "live_blog" && <EnVivo data-testid='envivo'/>}
        </div>
        {author && (
          <div className={styles["destacada-container-text"]}>
            {title !== "" && (
              <h1
                className={styles["destacada-title"]}
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {summary !== "" && (
              <div className={hasBackground
                  ? `${styles["background"]} ${styles["destacada-summary"]}`
                  : styles["destacada-summary"]}
              >
                {noTagsHtml}
              </div>
            )}
          </div>
        )}
      </a>

      {parsedAuthors && (
        <div
          className={styles["destacada-autor"]}
          dangerouslySetInnerHTML={{ __html: 'Por: ' + parsedAuthors }}
        />
      )}
    </>
  );
};

export default Destacada;
